<form
  [formGroup]="form"
  class="relative"
  (keydown.Enter)="$event.preventDefault(); openSelector()"
  (keydown.arrowdown)="$event.preventDefault(); openSelector()"
  (keypress)="searchOnPress($event)"
>
  <div (click)="openSelector()">
    <div #contentSlot>
      <ng-content></ng-content>
    </div>

    @if (!contentSlot.children.length) {
      <lla-selector-card
        [label]="label"
        [value]="prefix ? prefix + selectedDisplayName : selectedDisplayName"
        [icon]="icon"
        [extraClasses]="extraClasses"
        [capitalizeLabel]="capitalizeLabel"
      ></lla-selector-card>
    }
  </div>

  <div class="absolute w-full -bottom-xs invisible {{ selectorClass }}">
    <mat-select
      #selectorRef
      formControlName="value"
      [panelWidth]="resolvedPanelWidth"
      [multiple]="multiSelect"
      (opened)="onOpenSelector()"
      (closed)="onCloseSelector()"
    >
      @if (isOpen) {
        @if (showHeader) {
          <mat-option class="header-option" disabled>{{ label }}</mat-option>
        }
        @if (searchable) {
          <mat-option class="search-option hover:bg-transparent!">
            <ngx-mat-select-search
              formControlName="searchText"
              [placeholderLabel]="searchPlaceholder"
              noEntriesFoundLabel=""
              [disableInitialFocus]="window.innerWidth <= mobileMaxWidth"
            ></ngx-mat-select-search>
          </mat-option>
        }
        <div class="pt-sm">
          <ng-content select="[slot=filter]"></ng-content>
        </div>
        @for (item of selectedItems; track item) {
          @let disableItem = getDisableItem(item.value);
          <mat-option
            class="normal-select-option"
            [ngClass]="{ 'single-select-mode': !multiSelect, 'no-active-style': !persistSelect }"
            [value]="item.value"
            [disabled]="
              (disableItem && (multiSelect ? !isSelected(item.value) : selectedId !== item.value)) ||
              (multiSelect && isSelectedLastItem(item.value))
            "
          >
            {{ item.label }}{{ disableItem?.reason ? ' - ' + disableItem?.reason : '' }}
          </mat-option>
        }
      }
    </mat-select>
  </div>
</form>
